import React from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {Card, Eyebrow, SectionHead} from '../../../_ui/_v3/primitives';

const ReviewCardStyled = styled(Card)`
  padding: 1.2rem 1.3rem;
  display: grid;
  gap: .5rem;
  margin-bottom: 1rem;

  p {
    margin: 0;
    color: ${props => props.theme.colors.inkSoft};
    max-width: 70ch;
    white-space: pre-wrap;
  }
`;

const ReviewTopStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: .4rem 1rem;

  .name { font-weight: 700; }
  .stars { color: ${props => props.theme.colors.brandText}; letter-spacing: .1em; }
  .date {
    font-size: .7rem;
    color: ${props => props.theme.colors.inkFaint};
    text-transform: uppercase;
    letter-spacing: .04em;
  }
`;

const stars = (note) => '★'.repeat(Math.round(note || 0)) + '☆'.repeat(Math.max(0, 5 - Math.round(note || 0)));

const ReviewsSection = ({site}) => {
  const {t, i18n} = useTranslation(['touristic-site']);
  const comments = (site.feedbacks && site.feedbacks.comments) || [];
  const ambassador = site.ambassador_review;

  const ambassadorContent = ambassador && ambassador.content;
  if (comments.length === 0 && !ambassadorContent) {
    return null;
  }
  return (
    <>
      <SectionHead>
        <Eyebrow>{t('v3.eyebrow.avis')}</Eyebrow>
        <h2>{t('v3.section.avis')}</h2>
      </SectionHead>
      {ambassadorContent && (
        <ReviewCardStyled>
          <ReviewTopStyled>
            <span className="name">{t('reviews.name')}</span>
          </ReviewTopStyled>
          <p>{ambassador.content}</p>
        </ReviewCardStyled>
      )}
      {comments.map((comment) => (
        <ReviewCardStyled key={comment.id}>
          <ReviewTopStyled>
            <span className="name">
              {(comment.user && comment.user.user_profile && comment.user.user_profile.firstname) || comment.username}
            </span>
            {comment.note != null && <span className="stars" aria-label={`${comment.note}/5`}>{stars(comment.note)}</span>}
            {comment.created_at && (
              <span className="date">
                {new Date(comment.created_at).toLocaleDateString(i18n.language === 'fr' ? 'fr-FR' : 'en-GB')}
              </span>
            )}
          </ReviewTopStyled>
          {comment.content && <p>{comment.content}</p>}
        </ReviewCardStyled>
      ))}
    </>
  );
};

export default ReviewsSection;
